import { GeneralErrorComponent } from './shared/components/general-error/general-error.component';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from "./shared/components/not-found/not-found.component";
import { Routes } from "@angular/router";
import { AuthGuard } from './shared/providers/guard/Auth/auth-guard.service';
import { AdminLayoutComponent } from './admin/components/theme/admin-layout/admin-layout.component';
import { AdminLoginComponent } from './admin/components/account/admin-login/admin-login.component';
import { FranchiseQrCodeComponent } from './franchises/qr-code/qr-code.component';

export const routes: Routes = [
  // {
  //   path: "",
  //   redirectTo: "/ar",
  //   pathMatch: "full"
  // },
  {
    path: ':lang', component: HomeComponent, data: { customHeader: true, customFooter: true }
  },
    {
    path: ":lang/franchises/license-details",
    component: FranchiseQrCodeComponent ,data: { customHeader: true, customFooter: true }
  },
  {
    path: ":lang/auth", pathMatch: 'full',
    loadChildren: () =>
      import("./auth/auth.module").then(mod => mod.AuthModule)
  },
  {
    path: ":lang/franchise-creation",
    loadChildren: () =>
      import("./franchise-creation/franchise-creation.module").then(
        mod => mod.FranchiseCreationModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: ":lang/franchise-update",
    loadChildren: () =>
      import("./franchise-update/franchise-update.module").then(
        mod => mod.FranchiseUpdateModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },

  {
    path: ":lang/franchises",
    loadChildren: () =>
      import("./franchises/franchises.module").then(
        mod => mod.FranchisesModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: ":lang/requests",
    loadChildren: () =>
      import("./requests/requests.module").then(mod => mod.RequestsModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: ":lang/error", component: GeneralErrorComponent

  },
  {
    path: 'admin',
    component: AdminLayoutComponent,

    children: [
      {
        path: '',
        loadChildren: () => import('./admin/admin.module').then(mod => mod.AdminModule)
      }]
  },

  { path: "**", component: HomeComponent }
];
